module.exports = __webpack_public_path__ + "static/media/Cluster_bulk_uploader.795956bf.xlsx";